import { Component, OnInit } from "@angular/core";
import { AppService } from "@services/app.service";
import { DateTime } from "luxon";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit {
  public user;
  userType: string = "";

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.user = this.appService.user;
    this.userType = localStorage.getItem("userType");
  }

  logout() {
    this.appService.logout();
    localStorage.clear();
  }

  formatDate(date) {
    return DateTime.fromRFC2822(date).toFormat("dd LLL yyyy");
  }
}
